import { Checkbox } from '@gsa/afp-component-library';
import { useSelector } from 'react-redux';
import { useAppAbility } from '@gsa/afp-shared-ui-utils';
import {
  StoreOperations,
  StoreSubjects,
} from '../../../../constants/constants';
import AdditionalsOptionSelection from './option-selection';
import './option-selection.scss';

export default function AdditionalsVehicleTabs() {
  const { selectedReasonForRequest } = useSelector(
    (state) => state.additionalsReducer,
  );
  const ability = useAppAbility();
  const canManageReferrals = ability.can(
    StoreOperations.Manage,
    StoreSubjects.VehicleReferral,
  );

  return (
    <>
      <div>
        <div className="margin-top-5 margin-bottom-5">
          <h3>Reason for request</h3>
          <div>{selectedReasonForRequest}</div>
        </div>

        <div className="review-acknowledge padding-5 margin-bottom-5">
          <Checkbox checked={true} disabled />
          <div className="acknowledge-section margin-left-5">
            By requesting a leased vehicle through GSA Fleet, I acknowledge that
            this is a <strong>long-term vehicle need </strong> intended for
            regular, ongoing operational use. For short-term vehicle needs, I
            can utilize the <strong>Short-Term Rental Program</strong> instead.
          </div>
        </div>
      </div>

      <AdditionalsOptionSelection />
    </>
  );
}
